import { useEffect, useState } from "react";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { resolveImageUrl } from "../lib/url";
import Seo from "../components/Seo";

const tabs = [
  { key: "all", label: "Alle" },
  { key: "dance", label: "Tanz" },
  { key: "music", label: "Musik" },
  { key: "event", label: "Events" },
  { key: "workshop", label: "Workshops" },
];

const Galerie = () => {
  const { t } = useLang();
  const [active, setActive] = useState("all");
  const [items, setItems] = useState([]);

  useEffect(() => {
    const q = active === "all" ? "" : `?category=${active}`;
    api.get(`/public/gallery${q}`).then(r => setItems(r.data));
  }, [active]);

  return (
    <div data-testid="gallery-page">
      <Seo
        title="Galerie – Tamilische Musik, Tanz & Events"
        description="Eindrücke aus dem Akademie-Alltag, Workshops, Auftritten und KAAVIYAM. Bildergalerie der KK Academy."
        path="/galerie"
      />
      <section className="py-20 max-w-7xl mx-auto px-6">
        <div className="text-xs uppercase tracking-[0.3em] text-primary mb-4">{t("nav.gallery")}</div>
        <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05] max-w-3xl mb-10">{t("home.galleryTitle")}</h1>
        <div className="flex gap-2 mb-10 flex-wrap">
          {tabs.map(tb => (
            <button
              key={tb.key}
              onClick={() => setActive(tb.key)}
              data-testid={`gallery-tab-${tb.key}`}
              className={`px-4 py-2 rounded-full text-xs uppercase tracking-[0.2em] transition-colors ${active === tb.key ? "bg-primary text-primary-foreground" : "border border-border text-muted-foreground hover:text-foreground"}`}
            >
              {tb.label}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {items.map((g) => (
            <div key={g.id} className="aspect-square overflow-hidden rounded-lg group">
              <img src={resolveImageUrl(g.url)} alt={g.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Galerie;
